import { Backdrop, Box, CircularProgress } from "@mui/material";
import { useAsync, useMountEffect } from "@react-hookz/web";
import { useParams } from "react-router-dom";
import { getStore } from "@/api/store";
import { StoreNotFound } from "@/components/dashboard";
import { CheckoutPage } from "./components/CheckoutPage";
import { InvoiceCheckoutPage } from "./components/InvoiceCheckoutPage";

const Checkout = () => {
    const { store_id } = useParams();

    const [getStoreState, getStoreActions] = useAsync(getStore);

    // fetch store on mount
    useMountEffect(() => {
        if (store_id) getStoreActions.execute(store_id);
    });

    if (getStoreState.status === "loading")
        return (
            <Backdrop
                open={getStoreState.status === "loading"}
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <CircularProgress sx={{ color: "#ffffff" }} />
            </Backdrop>
        );

    if (getStoreState.error) return <StoreNotFound />;

    if (!getStoreState.result) return null;

    const store = getStoreState.result;

    if (store.is_using_invoice) {
        return (
            <Box
                bgcolor={"#fff"}
                minHeight={"100vh"}
                width={"100%"}
                overflow={"auto"}
            >
                {/* Render Invoice Checkout Page */}
                <InvoiceCheckoutPage store={store} />
            </Box>
        );
    } else {
        return (
            <Box
                bgcolor={"#F3F4F6"}
                minHeight={"100vh"}
                width={"100%"}
                overflow={"auto"}
            >
                {/* Render Checkout Page */}
                <CheckoutPage store={store} />
            </Box>
        );
    }
};

export default Checkout;
